// Shared formatting helpers — direct port of the originals in
// sync_health_report.py JS so visual semantics stay identical.

export const RECENT = 14;
export const ROLLING = 7;
export const MIN_RUNS = 10;
export const MIN_NIGHTS = 5;
export const TOP_N = 5;

export const FAULT_NAMES = ['success', 'ours', 'theirs', 'shared', 'unknown'];

export const FAULT_COLORS = {
    ours: '#e76f51',
    theirs: '#f4a261',
    shared: '#e9a23b',
    unknown: '#6c757d',
};

// MUI palette overrides — used by trend chart + small-multiples.
export const SERIES_PALETTE = ['#e76f51', '#f4a261', '#2a9d8f', '#264653', '#e9a23b'];

export const fmtPct = (v) =>
    v == null || isNaN(v) ? '—' : `${v.toFixed(2)}%`;

export const fmtDelta = (v) => {
    if (v == null || isNaN(v)) return { text: '—', cls: 'delta-zero' };
    const cls = v > 0 ? 'delta-pos' : v < 0 ? 'delta-neg' : 'delta-zero';
    const sign = v > 0 ? '+' : '';
    return { text: `${sign}${v.toFixed(2)} pp`, cls };
};

export const rateClass = (v) => {
    if (v == null || isNaN(v)) return 'meh';
    if (v >= 95) return 'good';
    if (v >= 80) return 'warn';
    return 'bad';
};

export const RATE_COLORS = {
    good: '#2a9d8f',
    warn: '#e9a23b',
    bad: '#e76f51',
    meh: '#6c757d',
};

export const trajectory = (delta) => {
    if (delta == null || isNaN(delta)) return { label: 'Unknown', color: '#6c757d' };
    if (delta > 2) return { label: 'Improving', color: '#2a9d8f' };
    if (delta < -2) return { label: 'Declining', color: '#e76f51' };
    return { label: 'Stable', color: '#6c757d' };
};

export function pctOf(n, d) {
    return d > 0 ? `${((n / d) * 100).toFixed(1)}%` : '—';
}
